import { useEffect, useState } from "react";
import SessionsApi from "../../../api/sessionApi";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import { RefoundSession } from "../../../types/TypeSession";
import Notify, { SuccesNotify } from "../../../utils/toaster";
import SessionInfoBlock, {
  SessionForDisplay,
} from "../shared/SessionInfoBlock/SessionInfoBlock";
import s from "./AwaitingRefound.module.css";
import SessionsTable from "./SessionsTable/SessionsTable";

const AwaitingRefund = () => {
  const token = localStorage.getItem("token");
  const [paganation, setPaganation] = useState({
    page: 0,
    rowPerPage: 5,
    total: 0,
  });
  const [sessionsData, setSessionsData] = useState<
    RefoundSession[] | undefined
  >();
  const [selectedSession, setSelectedSession] = useState<
    RefoundSession | undefined
  >();
  const [actionLoaders, setActionLoaders] = useState({ loadSessions: true });
  const [payoutConfirmModal, setPayoutConfirmModal] = useState(false);
  const [refundConfirmModal, setRefundConfirmModal] = useState(false);

  useEffect(() => {
    (async () => {
      if (!token) return;
      setActionLoaders((prev) => ({ ...prev, loadSessions: true }));
      const response = await SessionsApi.getSessionsWaitingForRefund(
        token,
        paganation.page + 1,
        paganation.rowPerPage,
      );

      setActionLoaders((prev) => ({ ...prev, loadSessions: false }));
      if (response.sessions && response.status) {
        setSessionsData(response.sessions);
        setPaganation((prev) => ({ ...prev, total: response.amount }));
      }
    })();
  }, [paganation.page, paganation.rowPerPage]);

  const payoutSession = async () => {
    if (!token || !selectedSession) return;
    const payload = {
      userId: selectedSession.clients[0]._id,
      sessionId: selectedSession._id,
    };
    const response = await SessionsApi.payOutSession(token, payload);
    if (response.status) {
      SuccesNotify("Pasyout successful");
      setPayoutConfirmModal(false);
      setSessionsData((prev) =>
        prev?.filter((el) => el._id !== selectedSession._id),
      );
      setSelectedSession(undefined);
    }
    if (!response.status && response.message) {
      Notify(response.message);
    }
  };

  const refundSession = async () => {
    if (!token || !selectedSession) return;
    const payload = {
      userId: selectedSession.specialists[0]._id,
      sessionId: selectedSession._id,
    };
    const response = await SessionsApi.refundSession(token, payload);
    if (response.status) {
      SuccesNotify("Refund successful");
      setRefundConfirmModal(false);
      setSessionsData((prev) =>
        prev?.filter((el) => el._id !== selectedSession._id),
      );
      setSelectedSession(undefined);
    }
    if (!response.status && response.message) {
      Notify(response.message);
    }
  };

  return (
    <div className={s.container}>
      <div className={s.mainContent}>
        <>
          <div
            className={
              selectedSession
                ? `${s.tableBlock} ${s.mobileTableBlockHidden}`
                : `${s.tableBlock} ${s.mobileTableBlockVisible}`
            }
          >
            <SessionsTable
              variant="refund"
              count={paganation.total}
              page={paganation.page}
              rows={sessionsData ?? []}
              rowsPerPage={paganation.rowPerPage}
              setPagination={setPaganation}
              loader={actionLoaders.loadSessions}
              onSelectSession={setSelectedSession}
              selectedSession={selectedSession}
            />
          </div>
          <div
            className={
              selectedSession
                ? `${s.sessionInfoBlock} ${s.sessionInfoBlockActive} ${s.mobileSessionVisible}`
                : `${s.sessionInfoBlock} ${s.mobileSessionHidden}`
            }
          >
            {selectedSession && (
              <SessionInfoBlock
                session={selectedSession as unknown as SessionForDisplay}
                onBack={() => setSelectedSession(undefined)}
                statusBadge="Awaiting refund"
                renderActions={() => (
                  <>
                    <button
                      className={s.actionBtn}
                      onClick={() => setRefundConfirmModal(true)}
                    >
                      Refund
                    </button>
                    <button
                      className={s.actionBtn}
                      onClick={() => setPayoutConfirmModal(true)}
                    >
                      Payout
                    </button>
                  </>
                )}
              />
            )}
          </div>
        </>
      </div>
      <ConfirmationModal
        setModalVisible={setPayoutConfirmModal}
        modalVisible={payoutConfirmModal}
        confirmFunc={payoutSession}
        confirmTitle="Are you sure you want to send money to a specialist?"
      />
      <ConfirmationModal
        setModalVisible={setRefundConfirmModal}
        modalVisible={refundConfirmModal}
        confirmFunc={refundSession}
        confirmTitle="Are you sure you want to return the client's money?"
      />
    </div>
  );
};

export default AwaitingRefund;
